// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".r-pagination-control{display:flex;flex-flow:column;margin:0 auto;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.r-pagination-control{height:36px}}.r-pagination-control-buttons-wrapper{display:flex;flex:1 0}.r-pagination-control-button{display:flex;justify-content:space-between;align-items:center;margin:var(--pagination-buttons-margin)}", ""]);
// Exports
module.exports = exports;
